import React from "react";
import classNames from "classnames";
import { FormattedMessage } from "react-intl";
import "./FilterTabs.styl";

export default function FilterTabs({
  activeFilter,
  onFilterChange,
  onClearFilter,
  filters = [
    { id: "ordered", labelId: "filterOrdered" },
    { id: "paused", labelId: "filterPaused" },
    { id: "open", labelId: "filterEditable" },
  ],
  showClearFilter = true
}) {

  return (
    <div className="filter-tabs-container">
      <div className="filter-tabs">
        {filters.map((filter) => (
          <button
            key={filter.id}
            className={classNames("filter-tab", {
              active: activeFilter === filter.id
            })}
            onClick={() => onFilterChange(filter.id)}
          >
            <FormattedMessage id={filter.labelId} />
          </button>
        ))}
      </div>
      {showClearFilter && (
        <div className="clear-filter-container">
          <button 
            className={classNames("clear-filter", {
              "disabled": !activeFilter
            })} 
            onClick={activeFilter ? onClearFilter : undefined}
            disabled={!activeFilter}
          >
            <FormattedMessage id="clearFilter" />
          </button>
        </div>
      )}
    </div>
  );
}